import React from 'react';
import { Crown, Scale, Package, Wallet, CheckCircle2, CircleAlert } from 'lucide-react';

const usd = (n) => `$${Number(n || 0).toFixed(2)}`;

export const ResumenFidelidad = ({ resumen }) => {
  if (!resumen) return null;
  const items = [
    { icon: Package, label: 'Paquetes enviados', value: resumen.total_paquetes, id: 'total-paquetes' },
    { icon: Scale, label: 'Kilos enviados', value: `${resumen.kilos_totales} kg`, id: 'kilos' },
    { icon: Wallet, label: 'Por pagar', value: usd(resumen.facturas_pendientes_usd), id: 'por-pagar' },
  ];
  return (
    <div className="space-y-4" data-testid="resumen-fidelidad">
      <div className="grid md:grid-cols-3 gap-4">
        <div className="rounded-xl p-6 text-white" style={{ background: 'var(--sendhapy-teal)' }}>
          <div className="flex items-center gap-2 mb-3">
            <Crown size={20} style={{ color: 'var(--sendhapy-yellow)' }} />
            <span className="text-sm text-white/80">Tu categoría SendHapy</span>
          </div>
          <p className="text-3xl font-bold" data-testid="cliente-nivel">{resumen.nivel}</p>
          <p className="text-sm text-white/80 mb-3" data-testid="cliente-kg-12m">{resumen.kg_12m} kg entregados en los últimos 12 meses</p>
          {resumen.siguiente ? (
            <>
              <div className="h-2 rounded-full bg-white/20 overflow-hidden">
                <div className="h-full rounded-full transition-all duration-700" style={{ width: `${resumen.progreso}%`, background: 'var(--sendhapy-yellow)' }} />
              </div>
              <p className="text-xs text-white/80 mt-2" data-testid="cliente-nivel-progreso">Te faltan {resumen.falta_kg} kg para ser {resumen.siguiente}</p>
            </>
          ) : <p className="text-sm text-white/80">Estás en la categoría más alta.</p>}
        </div>
        <div className="md:col-span-2 grid grid-cols-3 gap-4">
          {items.map((i) => (
            <div key={i.id} className="bg-white rounded-xl p-5 shadow-sm" data-testid={`resumen-${i.id}`}>
              <i.icon size={22} style={{ color: 'var(--sendhapy-teal)' }} className="mb-2" />
              <p className="text-2xl font-bold">{i.value}</p>
              <p className="text-gray-500 text-sm">{i.label}</p>
            </div>
          ))}
        </div>
      </div>
      <details className="bg-white rounded-xl p-5 shadow-sm" data-testid="fidelidad-condiciones">
        <summary className="cursor-pointer font-semibold" style={{ color: 'var(--sendhapy-teal)' }}>Condiciones del programa y mi actividad</summary>
        <div className="grid md:grid-cols-2 gap-6 mt-4 text-sm">
          <div>
            <p className="mb-2">Tu categoría se calcula con los kilos de tus paquetes entregados y pagados en los últimos 12 meses:</p>
            <ul className="space-y-1 text-gray-600">
              {resumen.umbrales.map((u, i) => {
                const hasta = resumen.umbrales[i + 1]?.desde_kg;
                return <li key={u.nivel}>• <b>{u.nivel}</b>: {hasta ? `de ${u.desde_kg} a menos de ${hasta} kg` : `${u.desde_kg} kg o más`}</li>;
              })}
            </ul>
            <p className="mt-3 mb-1">Para disfrutar los beneficios necesitas:</p>
            <p className="flex items-center gap-2">{resumen.condicion_actividad ? <CheckCircle2 size={16} className="text-green-600" /> : <CircleAlert size={16} className="text-orange-500" />} Un envío entregado en los últimos {resumen.dias_actividad} días</p>
            <p className="flex items-center gap-2">{resumen.condicion_pagos_al_dia ? <CheckCircle2 size={16} className="text-green-600" /> : <CircleAlert size={16} className="text-orange-500" />} Pagos al día</p>
          </div>
          <div>
            <p className="mb-2 font-medium">Actividad reciente</p>
            {resumen.actividad_reciente.length === 0 ? <p className="text-gray-400">Aún no hay entregas en los últimos 12 meses.</p> :
              resumen.actividad_reciente.map((a) => <p key={a.tracking} className="flex justify-between border-b py-1"><span className="font-mono text-xs">{a.tracking}</span><span>{a.kg} kg · {new Date(a.fecha).toLocaleDateString('es-CR')}</span></p>)}
            {resumen.historial_niveles?.length > 0 && (<>
              <p className="mt-4 mb-1 font-medium">Cambios de categoría</p>
              {resumen.historial_niveles.map((h) => <p key={h.fecha} className="text-gray-600">{new Date(h.fecha).toLocaleDateString('es-CR')}: {h.anterior || 'inicio'} → <b>{h.nuevo}</b></p>)}
            </>)}
          </div>
        </div>
      </details>
    </div>
  );
};
